<template>
  <b-modal class="welcome-modal" ref="modal" size="lg" centered laze :hide-header="true" :hide-footer="true"
    :title="getTitle()" :visible="true" no-fade no-close-on-backdrop>
    <!-- @hidden="onHide" -->

    <LoadingSpinner v-if="isLoading" />
    <Alerts />

    <div class="text-center px-3" v-if="step === steps.first">
      <b-row class="justify-content-around mb-3">
        <img src="/images/GS Logo Small.jpg" width="230" class="img-responsive" />
        <img src="/images/Pitney Bowes Logo.png" width="230" class="img-responsive" />
      </b-row>

      <p>
        GrandShipper is a partner of Pitney Bowes to fund your shipping account.&nbsp;&nbsp;Please choose one of the
        following options below
      </p>

      <b-btn :href="signup.url" target="_blank" size="sm" class="default rounded-pill pb-btn"
        style="padding: 2px 10px;">Create my Pitney Bowes Account</b-btn>

      <div class="mt-5">
        Already have a Pitney Bowes Merchant Account?
        <b-btn @click="step = steps.connect" variant="primary" size="md">Login</b-btn>
      </div>
    </div>

    <div class="px-4" v-if="step === steps.connect">
      <div v-if="error" class="mb-2">
        <p class="alert alert-danger" style="margin: 0 .8rem 1px;">
          <i class="glyphicon glyphicon-exclamation-sign text-danger"></i>
          <small>Email and Password didn't match, please try again.</small>
        </p>
      </div>

      <div class="text-center">
        <img src="/images/Pitney Bowes Logo.png" width="230" class="img-responsive" />
        <p>
          Link your Pitney Bowes Merchant Account with Grandshipper.&nbsp;&nbsp;Please enter your Pitney Bowes
          credentials below.
        </p>
      </div>

      <b-row class="justify-content-center">
        <b-col sm="8">
          <b-form ref="connectForm" @submit="onConnectSubmit">
            <b-input-group class="mb-3 default">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="icon-user"></i>
                </span>
              </div>
              <b-form-input id="connect-username" type="text" v-model="connectForm.username" required
                placeholder="Pitney Bowes Email"></b-form-input>
            </b-input-group>
            <b-input-group class="mb-3 default">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="icon-lock"></i>
                </span>
              </div>
              <b-form-input id="connect-password" :type="isPasswordVisible ? 'text' : 'password'"
                v-model="connectForm.password" required placeholder="Pitney Bowes Password"></b-form-input>
              <b-input-group-append>
                <b-btn variant="primary" class="default pb-btn" @click="isPasswordVisible = !isPasswordVisible"><i
                    :class="['fa', isPasswordVisible ? 'fa-eye' : 'fa-eye-slash',]" aria-hidden="true"></i></b-btn>
              </b-input-group-append>
            </b-input-group>
            <!-- REFERRAL CHECKBOX -->
            <!-- <div class="text-center">
              <b-form-checkbox v-model="connectForm.referral" name="referral" value="yes" unchecked-value="no">
                Referral Account?
              </b-form-checkbox>
            </div> -->
            <!-- <b-form-row>
              <b-col>
                <b-form-group label="Pitney Bowes Username:" label-for="connect-username" description>
                  <b-form-input
                    id="connect-username"
                    type="text"
                    v-model="connectForm.username"
                    required
                    placeholder="Enter your Pitney Bowes username"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Pitney Bowes Password:" label-for="connect-password" description>
                  <b-form-input
                    id="connect-password"
                    type="password"
                    v-model="connectForm.password"
                    required
                    placeholder
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row> -->
          </b-form>

          <div class="text-center">
            <b-btn class="default pb-btn rounded-pill" @click="onConnectSubmit" style="padding: 2px 10px;">Connect my
              Pitney Bowes Account</b-btn>
          </div>

          <div class="text-center" style="margin-top: 10px; font-size: 14px;">
            <a href="https://login2.pitneybowes.com/forgot-password?productId=shipperapplication&flow=v2&TargetResource=https:%2F%2Fpitneybowes.okta.com%2Foauth2%2Faus13gs0hnB5KIbVz1t7%2Fv1%2Fauthorize%3Fclient_id%3D7KBCxIR3F381AzL1TTLs%26scope%3Dopenid%26response_type%3Dtoken%2Bid_token%26response_mode%3Dform_post%26nonce%3D1111%26state%3D%2Fdashboard%26redirect_uri%3Dhttps:%2F%2Fwww.pbshippingmerchant.pitneybowes.com%2Fwelcome&email="
              target="_blank">Forgot password?</a>
          </div>

          <div class="text-center mt-5">
            Return to previous page -
            <b-btn @click="goBack" class="text-white" style="background-color: #858888; border: 1px solid #858888">Back
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="step === steps.origin">
      <div class="text-center">
        <h3>Create an origin address</h3>
      </div>

      <div class="px-3">
        <p>
          The origin address is your ship from address and will print on the label. &nbsp;This is a required section to
          be filled.
          <!-- &nbsp;If you already created one, please click on skip. -->
          <br> <br>
          <small>
            Tip: If you are Company, most will leave blank the First Name and Last Name fields.
          </small>
        </p>
      </div>

      <b-form @submit.prevent="onOriginSubmit" class="px-3">
        <b-row>
          <b-col sm="6" class="mb-2 pr-1">
            <b-input id="first_name" name="first_name" type="text" size="sm" v-model="originForm.first_name"
              placeholder="First Name"></b-input>
          </b-col>

          <b-col sm="6" class="mb-2 pl-1">
            <b-input id="last_name" name="last_name" type="text" size="sm" v-model="originForm.last_name"
              placeholder="Last Name"></b-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mb-2">
            <b-input id="company" name="company" type="text" size="sm" v-model="originForm.company"
              placeholder="Company"></b-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mb-2">
            <GoogleAutoComplete :g-class="['form-control', 'form-control-sm']" v-model="originForm.address"
              placeholder="Address" @change="onGoogleAddressChange"></GoogleAutoComplete>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" class="mb-2 pr-1">
            <b-input id="city" name="city" required type="text" size="sm" v-model="originForm.city" placeholder="City">
            </b-input>
          </b-col>

          <b-col sm="6" class="mb-2 pl-1">
            <b-select id="state" type="text" required size="sm" v-model="originForm.state" placeholder="State/Province"
              :options="stateSelectOptions"></b-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" class="mb-2 pr-1">
            <zip-code-input id="postal" type="text" size="sm" v-model="originForm.postal" required
              placeholder="Postal Code"></zip-code-input>
          </b-col>

          <b-col sm="6" class="mb-2 pl-1">
            <b-form-input value="US" size="sm" disabled></b-form-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mb-2 pr-1">
            <zip-code-input id="postal-origin" type="text" v-model="originForm.postal_origin" size="sm" required
              placeholder="Postal Code where the packages will be processed"></zip-code-input>
          </b-col>
          <b-col sm="6" class="mb-2 pl-1">
            <b-input id="phone" name="phone" type="text" required size="sm" v-model="originForm.phone"
              placeholder="Phone">
            </b-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" class="mb-2 text-center">
            <b-btn @click="verifyAddress" size="sm" variant="success"
              class="mt-0 rounded-pill default btn-light-blue-outline">
              <img class="verifyImg" src="/images/icons/verify-address-blue.png">
              Verify Address
            </b-btn>
          </b-col>
          <b-col sm="6" class="mb-2 text-center">
            <b-btn @click="onOriginSubmit" size="sm" variant="success" class="mt-0 rounded-pill default btn-blue">Create
              Origin</b-btn>
          </b-col>
        </b-row>

        <!-- <div class="text-center">
          Already created one - <a class="cursor-pointer" @click="onSkipOrigin">Skip</a>
        </div> -->
      </b-form>
    </div>

    <div v-if="step == steps.done" class="text-center">
      <h2>Great!</h2>
      <ThumbsUp ref="thumbsUp" :autoplay="false" :delay="300" />
      <p class="lead">To continue, let's create your first shipment.</p>
      <b-btn variant="primary" size="lg" @click="done()">Continue</b-btn>
    </div>

    <div v-if="step == steps.susp" class="text-center">
      <h3 style="color: red; align: center;">
        ACTION REQUIRED
      </h3>
      <p style="text-align: left;">
        We apologize for the inconvenience, but your account have been suspended for
        security reasons. We understand that this could be frustrating, but this is to
        protect both GrandShipper and our valued customers.
      </p>
      <p style="text-align: left;">
        Please reach out to <em>support@grandshipper.com</em>, and within 15 minutes up to 24
        hours, one of our account specialist will provide instructions to get you activated.
        If you email during the weekend, please allow the following business day for a
        reply.
      </p>

      <p style="text-align: left;">
        If we do not receive any communications within <strong>72 hours</strong>, your account will
        automatically be deactivated, and you can no longer login.
      </p>
      <p style="text-align: left;">
        Thank you advance for your patience and cooperation.
      </p>
    </div>

    <!-- <div slot="modal-footer" v-if="step === steps.first">
      <b-button
        :href="signup.url"
        target="_blank"
        variant="primary"
        size="md"
      >I don't have a Pitney Bowes Account</b-button>
      <b-button
        @click="step = steps.connect"
        variant="primary"
        size="md"
      >I have a Pitney Bowes Account</b-button>

      <div class="text-center mt-2">
        <b-button variant="secondary" @click="logout">Log out</b-button>
      </div>
    </div> -->

    <!-- <div slot="modal-footer" v-if="step === steps.signup">
      <b-button @click="onSignupSubmit">Next</b-button>
    </div>
    <div slot="modal-footer" v-if="step === steps.signup_iframe"></div>
    <div slot="modal-footer" v-if="step === steps.connect">
      <div class="text-center">
        <b-button @click="onConnectSubmit" variant="primary" size="lg">Connect Pitney Bowes Account</b-button>
        <br>
        <b-button @click="step = steps.first" variant="link" size="sm">Go back</b-button>
      </div>
    </div>
    <div slot="modal-footer" v-if="step === steps.origin">
      <b-button @click="onOriginSubmit" variant="success" size="lg">Next</b-button>
      <b-button @click="onSkipOrigin" variant="primary" size="lg">Skip</b-button>
    </div>
    <div slot="modal-footer" v-if="step === steps.done"></div> -->
  </b-modal>
</template>

<style lang="scss">
.pb-btn {
  background-color: #7246a0 !important;
  border-color: #7246a0 !important;
  color: #fff !important;
}

.welcome-modal {

  // .modal-body {
  //   border: 25px solid #7f7f7f !important;
  // }
  .modal-content {
    border-radius: 0 !important;
  }

  .modal-dialog {
    max-width: 550px;
  }

  .modal-footer {
    justify-content: center;
  }

  .signup-iframe {
    width: 100%;
    height: 657px;
    border: none;
  }
}

.welcome-verify {
  margin-top: 32px;
}
</style>
<script>
import GoogleAutoComplete from "./GoogleAutoComplete";
import LoadingSpinner from "./LoadingSpinner";
import Alerts from "./Alerts";
import ThumbsUp from "./Icons/ThumbsUp";
import countries from "../data/countries.js";
import states from "../data/states.js";
import formatters from "../formatters";
import { mapActions } from "vuex";

export default {
  components: {
    LoadingSpinner,
    Alerts,
    ThumbsUp
  },
  mixins: [
    GoogleAutoComplete
  ],
  props: [],
  data() {
    return {
      isPasswordVisible: false,
      steps: {
        first: 10,
        connect: 20,
        origin: 25,
        done: 30,
        susp: 403
      },
      step: 10,
      isLoading: false,
      error: false,

      signup: {
        url: null,
        form: {},
        iframe_url: null
      },

      connectForm: {
        username: null,
        password: null,
        // referral: "no"
      },

      originForm: {
        first_name: null,
        last_name: null,
        company: null,
        address: null,
        city: null,
        state: null,
        postal: null,
        country: null,
        actions: null,
        phone: null,
        postal_origin: null,
      },

      getTitle() {
        return "First";
      }
    };
  },
  computed: {
    countrySelectOptions() {
      return countries.getSelectOptions();
    },
    stateSelectOptions() {
      return states.getSelectOptions();
    }
  },
  created() { },
  mounted() {
    // this.step = this.steps.origin;
    axios.get("/pb/merchant_signup_url").then(response => {
      if (response.data.url) {
        this.signup.url = response.data.url;
      }
    });
    //window.addEventListener('message', this.onSignupIframeEvent);
  },
  methods: {
    ...mapActions(["addPrintJob", "refreshUserBalance", "refreshUser", "refreshShipsurance", "refreshShippingServices", "refreshCarrierRules", "refreshNotification"]),
    show() {
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    onHide() {
      if (this.step !== this.steps.done) {
        this.$refs.modal.show();
      }
      //this.$emit('hide')
    },

    goBack() {
      this.step = this.steps.first
      this.error = false
      this.connectForm.username = ''
      this.connectForm.password = ''
    },

    onSignupSubmit(e) {
      console.log(e);
      e.preventDefault();

      if (this.$refs.signupForm.checkValidity()) {
        this.isLoading = true;

        axios
          .post("/pb/signup", this.signup.form)
          .then(response => {
            if (response.data.url) {
              this.signup.iframe_url = response.data.url;
              this.step = this.steps.signup_iframe;
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    onSignupReset() { },
    onSignupIframeEvent(e) {
      let responseData = e.data;
      console.log(responseData);

      if (typeof responseData === "string") {
        responseData = JSON.parse(JSON.parse(responseData));

        if (!responseData.status || responseData.status !== "Success") {
          // emit error
          return;
        }

        console.log(responseData);

        this.isLoading = true;

        const requestData = {
          payment_info: responseData
        };

        axios
          .post("/pb/signup/2", requestData)
          .then(response => {
            if (response.data.url) {
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    onConnectSubmit(e) {
      e.preventDefault();
      const requestData = {
        username: this.connectForm.username,
        password: this.connectForm.password,
        // referral: this.connectForm.referral === "yes" ? true : false
      };

      this.isLoading = true;

      axios
        .post("/pb/connect/save", requestData)
        .then(response => {
          this.refreshUserBalance();
          this.step = this.steps.origin;
        })
        .catch(error => {
          console.log("error", error);
          if (error.response) {
            if (error.response.status === 403 && error.response.data.code === "SUSP") {
              this.step = this.steps.susp;
              // axios.post("/logout", {})
              //   .then(function () {
              //     localStorage.clear();
              //     this.step = this.steps.susp;
              //   });
            }
          }
          this.error = true
          // this.$refs.modal.$emit("alert", {
          //   message:
          //     "Invalid email address / password combination. Please try again.",
          //   type: "danger"
          // });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async onOriginSubmit() {
      const tzUrl = `${process.env.MIX_INTEG_URL}/get-tz?zipcode=${this.originForm.postal}`;
      const tz = await axios.get(tzUrl);
      const originData = Object.assign({}, this.originForm, { timezone: tz.data || "America/New_York" })

      if (![5, 10].includes(this.originForm.postal.length)) {
        this.$refs.modal.$emit("alert", {
          message: "Postal code is not valid, please double check.",
          type: "danger"
        });
        return;
      }
      if (this.originForm.postal_origin && ![5, 10].includes(this.originForm.postal_origin.length)) {
        this.$refs.modal.$emit("alert", {
          message: "Origin postal code is not valid, please double check.",
          type: "danger"
        });
        return;
      }

      if (!this.originForm.phone) {
        this.$refs.modal.$emit("alert", {
          message: "Phone number is a required field.  Please enter and resubmit.",
          type: "danger"
        });
        return;
      }
      try {
        await axios.post("/origin", originData)
        this.done();
        // this.step = this.steps.done;
        // setTimeout(() => {
        //   this.$refs.thumbsUp.start();
        // }, 240);
      } catch (error) {
        if (error.response) {
          console.log("ERROR: ", error.response.data.errors);
          const err = Object.values(error.response.data.errors)[0].pop();
          this.$toastr.e(`${error.response.data.message}: ${err}`);
        }
      }
    },
    onSkipOrigin() {
      this.done();
      // this.step = this.steps.done;
      // setTimeout(() => {
      //   this.$refs.thumbsUp.start();
      // }, 240);
    },

    async done() {
      await this.refreshUser();
      await Promise.all([
        this.refreshUserBalance(),
        this.refreshShippingServices(),
        this.refreshCarrierRules(),
        this.refreshNotification(),
        this.refreshShipsurance(),
      ]);

      // fake redirect
      this.hide();
      this.$router.push("/orders/shipped?status=first-label");
    },

    logout: function () {
      axios
        .post("/logout")
        .then(function (response) {
          localStorage.removeItem('shipper');
          window.location = "/";
        })
        .catch(function (error) {
          window.location = "/";
        });
    },

    onGoogleAddressChange(addr) {
      if (addr.country !== 'US') {
        this.$refs.modal.$emit('alert', {
          type: 'danger',
          message: 'Only addresses from US is allowed.'
        })
      } else {
        addr.postal = addr.postal_code
        addr.postal_origin = addr.postal_code
        addr.state = addr.state || addr.province
        this.originForm = Object.assign({}, this.originForm, addr);
      }
    },

    verifyAddress() {
      let address = formatters.address.toPb(this.originForm);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$refs.modal.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.originForm = Object.assign({}, this.originForm, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$refs.modal.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address is invalid!"
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/WelcomeModal.vue